import { api } from './apiClient';

export interface CoaControls {
  allowManualPosting: boolean; controlAccount: boolean; requireApproval?: boolean;
  costCenterRequired: boolean; projectRequired: boolean; profitCenterRequired?: boolean;
  departmentRequired?: boolean;
  defaultCostCenterId?: number | null; defaultProjectId?: number | null; defaultProfitCenterId?: number | null;
  gstApplicable: boolean; defaultTaxCodeId?: number | null; tdsApplicable: boolean; tdsSectionId?: number | null;
  bankAccount: boolean; reconciliationEnabled: boolean; reconciliationType?: string | null;
  currencyPolicy?: 'ALL' | 'BASE' | 'SPECIFIC'; currency: string; fxRevaluation?: boolean;
}
export interface CoaAccount {
  id: number; account_code: string; account_name: string;
  account_type: 'ASSET' | 'LIABILITY' | 'EQUITY' | 'INCOME' | 'EXPENSE';
  parent_id: number | null; is_active: boolean; is_default: boolean;
  created_at: string; updated_at: string;
  group: string; normalBalance: 'Dr' | 'Cr';
  isGroup?: boolean; accountStatus?: 'ACTIVE' | 'INACTIVE' | 'BLOCKED'; description?: string | null;
  childCount: number; isParent: boolean; isLeaf: boolean; level: number;
  txnCount: number; lastUsed: string | null;
  totalDebit: number; totalCredit: number; balance: number; balanceType: 'Dr' | 'Cr';
  used: boolean; mappings: string[]; controls: CoaControls;
}
export interface CoaSummary {
  totalAccounts: number; active: number; inactive: number; parent: number; leaf: number;
  system: number; custom: number; unused: number; used: number;
  byType: { type: string; count: number }[];
  byGroup: { group: string; count: number }[];
}
export interface CoaValidationIssue { severity: 'error' | 'warning'; kind: string; title: string; detail: string; accountId: number | null; }
export interface CoaValidation { summary: { checksPassed: number; warnings: number; errors: number; total: number }; issues: CoaValidationIssue[]; }

export const coaService = {
  summary: (): Promise<CoaSummary> => api.get('/coa/summary'),
  accounts: (): Promise<{ accounts: CoaAccount[] }> => api.get('/coa/accounts'),
  validation: (): Promise<CoaValidation> => api.get('/coa/validation'),
};

export default coaService;
